import React, { useEffect } from 'react';
import './Video.scss';

const Video = () => {
  useEffect(() => {
    // Video Modal JavaScript - orijinal script.js'ten
    const setupVideoModal = () => {
      const videoContainer = document.querySelector('.video-container');
      const playButton = document.querySelector('.play-button');

      const openModal = () => {
        if (document.querySelector('.video-modal')) return;

        const modal = document.createElement('div');
        modal.className = 'video-modal';
        modal.innerHTML = `
          <div class="video-modal-content" style="border-radius: 10px;">
            <button class="close-video">
              <img src="icons/close.svg" alt="Close" style="filter: invert(1);">
            </button>
            <div class="video-wrapper">
              <iframe width="560" height="315" 
                src="https://www.youtube.com/embed/_0vNF5uCmIE?autoplay=1" 
                title="Hayat Fintek Video" 
                frameborder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                allowfullscreen>
              </iframe>
            </div>
          </div>
        `;
        
        document.body.appendChild(modal);
        document.body.style.overflow = 'hidden';
        
        setTimeout(() => {
          modal.classList.add('active');
        }, 10);

        const closeButton = modal.querySelector('.close-video');
        closeButton.addEventListener('click', closeModal);
        modal.addEventListener('click', function(e) {
          if (e.target === modal) {
            closeModal();
          }
        });

        const handleEscKey = function(e) {
          if (e.key === 'Escape') {
            closeModal();
            document.removeEventListener('keydown', handleEscKey);
          }
        };
        document.addEventListener('keydown', handleEscKey);
      };

      const closeModal = () => {
        const modal = document.querySelector('.video-modal');
        if (modal) {
          modal.classList.remove('active');
          setTimeout(() => {
            document.body.removeChild(modal);
            document.body.style.overflow = '';
          }, 300);
        }
      };

      if (videoContainer && playButton) {
        videoContainer.addEventListener('click', openModal);
        playButton.addEventListener('click', function(e) {
          e.stopPropagation();
          openModal();
        });
      }
    };

    setupVideoModal();
  }, []);

  return (
    <section className="video-section">
      <div className="container">
        <h2 className="section-title" data-aos="fade-up" data-aos-duration="900">Hayat Finans ile ortak geliştirilen markamız: Hayat Pay</h2>
        <div className="video-container" data-aos="fade-up" data-aos-duration="1000">
          <img src="images/hayatpay.png" alt="Video Thumbnail" />
          <div className="play-info">
            <div className="play-button">
              <img src="icons/play.svg" alt="Play" />
            </div>
            <div className="play-text"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Video;
